import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ToolCallState } from './types';

type Props = {
  toolCall: ToolCallState;
  onConfirm: (toolId: string) => void;
  onCancel: (toolId: string) => void;
};

const AiChatConfirm: React.FC<React.PropsWithChildren<Props>> = ({
  toolCall,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <div className="ai-chat-confirm">
      <p>{toolCall.confirmSummary || t('aiChat.confirmation.message')}</p>
      <div className="ai-chat-confirm-actions">
        <button
          className="ai-chat-confirm-btn primary"
          onClick={() => onConfirm(toolCall.id)}>
          {t('aiChat.confirmation.confirm')}
        </button>
        <button
          className="ai-chat-confirm-btn secondary"
          onClick={() => onCancel(toolCall.id)}>
          {t('aiChat.confirmation.cancel')}
        </button>
      </div>
    </div>
  );
};

export default AiChatConfirm;
